/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 7/18/20
 *
 */
import BaseObject from "@shared/BaseObject";
import FeatureItem from "@shared/Subscription/Features/FeatureItem";
import {Type} from "class-transformer";

export default class AddonItem extends BaseObject {

	priceModifierId: string = null
	name: string = null
	description: string = null
	price: number = null
	units = null //holds how many units this addon provides. ex 10GB
	isRecurring: boolean = false

	@Type(() => FeatureItem)
	featureItems: FeatureItem[] = []


	constructor(name: string, price: number, isRecurring: boolean) {
		super();
		this.name = name;
		this.price = price;
		this.isRecurring = isRecurring;
	}
}
